import * as React from 'react'
import styled from '@emotion/styled'
import { rem } from 'polished'
import { withTheme, css, Global } from '@emotion/react'
import {
  MenuButton as MenuButtonComponent,
  MenuItem as MenuItemComponent,
} from '@reach/menu-button'
import {
  Tab as TabComponent,
  TabList as TabListComponent,
  TabPanels as TabPanelsComponent,
  Tabs as TabsComponent,
} from './ReachCustom/index'

/*
 * The Reach MenuButton creates a customizeable, a11y friendly, dropdown menu.
 * We need global styles here because the dropdown is created outside of our component
 */
export const GlobalStyles = withTheme(({ theme }) => (
  <Global
    styles={css`
      [data-reach-menu] {
        position: absolute;
        display: block;
        background-color: ${theme.colors.light.base.hex};
      }

      [data-reach-menu-item] {
        cursor: pointer;
        padding: ${theme.spacing.xs};
      }
    `}
  />
))

export const TabList = styled(TabListComponent)(
  ({ theme, isVertical }) => css`
    background-color: white;

    ${isVertical
      ? `
        border-bottom: 0px;
        border-top-left-radius: ${theme.radius};
        border-bottom-left-radius: ${theme.radius};

        button:first-of-type {
          border-top-left-radius: ${theme.radius};
        }
      `
      : `
        overflow-x: auto;

        &.tab-list {
          display: flex;
        }

        button {
          width: 100%;
          min-width: fit-content;
          margin-right: 0;
          border-radius: 0;

          &:first-of-type {
            border-top-left-radius: ${theme.radius};
          }

          &:last-of-type {
            border-top-right-radius: ${theme.radius};
          }
        }

      `}
  `
)

export const Tabs = styled(TabsComponent)(
  ({ theme, isVertical }) => css`
    ${isVertical &&
    `
        border-radius: ${theme.radius};
        box-shadow: ${theme.shadow};
        display: grid;
        grid-template-columns: 2fr 4fr;
    `}
  `
)

export const TabPanels = styled(TabPanelsComponent)(
  ({ theme, isVertical }) => css`
    padding: ${theme.spacing.sm};
    background-color: white;

    .tab-panel *:not(.leshen-link-button-wrapper *) {
      color: black;
    }

    ${isVertical &&
    `
      border-top-right-radius: ${theme.radius};
      border-bottom-right-radius: ${theme.radius};
      padding: ${theme.spacing.lg};
      border: 1px ${theme.colors.light.base.hex};
      border-bottom: 0;
    `}
  `
)

export const Tab = styled(TabComponent)(
  ({ theme, isVertical, isSelected }) => css`
    cursor: pointer;
    border: 0;
    padding: ${theme.spacing.sm};
    position: relative;
    margin: 0 6px 0 0;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
    background-color: white;
    color: ${isSelected
      ? `${theme.colors.primary.base.hex}`
      : '#707579'} !important;
    margin-left: 0;
    border-bottom: 2px solid #cfcfcf;

    span {
      color: ${isSelected
        ? `${theme.colors.primary.base.hex}`
        : '#707579'} !important;
      font-weight: ${isSelected ? 'bold' : 'normal'} !important;
    }

    &:active {
      border-bottom: 3px solid ${theme.colors.primary.base.hex};

      span {
        color: ${theme.colors.primary.base.hex};
        font-weight: bold;
      }
    }

    ${isVertical &&
    `
        border-radius: 0;
        border: 0px;
        width: 100%;
        margin: 0;
        text-align: left;
        color: ${
          isSelected ? `${theme.colors.primary.base.hex}` : '#707579'
        } !important;
        border-right: 3px solid white;

        span {
          color: ${isSelected ? `${theme.colors.primary.base.hex}` : '#707579'};
        }

        &:hover {
          border: 0;
          border-right: 3px solid ${theme.colors.primary.base.hex};
        }
      `};

    ${isVertical &&
    isSelected &&
    `
      border-right: 3px solid ${theme.colors.primary.base.hex};

      span {
        color: black;
      }
    `}

    ${isSelected &&
    !isVertical &&
    `
      border-bottom: 3px solid ${theme.colors.primary.base.hex};

      span {
        color: {theme.colors.primary.base.hex};
        font-weight: bold;
        color: ${
          isSelected ? `${theme.colors.primary.base.hex}` : '#707579'
        } !important;
      }
    `}
  `
)

export const Wrapper = styled.div`
  box-shadow: ${({ theme }) => theme.shadow};
`

export const InnerWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.sm};
  background-color: white !important;

  * :not(button, button span, a) {
    color: initial !important;
  }
`

export const MenuButton = styled(MenuButtonComponent)`
  color: ${({ theme }) => theme.colors.light.base.hex};
  font-size: ${({ theme }) => rem(theme.fonts.body.lg.size)};
  padding: ${({ theme }) => theme.spacing.xs};
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  border: 1px solid ${({ theme }) => theme.colors.primary.base.hex};
  color: ${({ theme }) => theme.colors.primary.base.hex} !important;
  background-color: white !important;
  box-shadow: ${({ theme }) => theme.shadow};

  svg {
    fill: ${({ theme }) => theme.colors.primary.base.hex};
  }
`

export const MenuItem = styled(MenuItemComponent)`
  &[data-reach-menu-item] {
    color: ${({ selected }) =>
      selected && `${({ theme }) => theme.colors.primary.base.hex}`};
    background-color: white;

    &:hover {
      span {
        color: ${({ theme }) => theme.colors.primary.base.hex};
      }
    }
  }
`
